/*
 * Copyright (c) 2002-2017 "Neo Technology,"
 * Network Engine for Objects in Lund AB [http://neotechnology.com]
 *
 * This file is part of Neo4j.
 *
 * Neo4j is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import * as CypherTypes from '../../lang/CypherTypes';
import * as CompletionTypes from '../CompletionTypes';
import { TreeUtils } from '../../util/TreeUtils';

export default (element) => {
  const mapLiteralContext = TreeUtils.findParent(element, CypherTypes.MAP_LITERAL_CONTEXT);
  const propertiesContext = TreeUtils.findParent(element, CypherTypes.PROPERTIES_CONTEXT);

  if (mapLiteralContext) {
    const text = element.getText();
    if (text === '}') {
      return [];
    }
    return [
      { type: CompletionTypes.PROPERTY_KEY },
    ];
  }

  if (propertiesContext) {
    const text = element.getText();
    if (text === '}') {
      return [];
    }
    if (/\s+/.test(text)) {
      return [];
    }
    return [
      { type: CompletionTypes.PROPERTY_KEY },
      { type: CompletionTypes.PARAMETER },
    ];
  }

  return [];
};



// WEBPACK FOOTER //
// ./node_modules/cypher-editor-support/src/completion/rules/rulePropInMapLiteral.js